import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";

import signInImage from "shared/dist/assets/images/signIn.png";
import { SNETButton } from "shared/dist/components";
import DefaultUserIcon from "shared/dist/assets/images/defaultUser.png";

import UserConfirmationModal from "../../../Components/UserConfirmationModal";

import { loggedInDetails, loggedOutDetails } from "./content";
import { userPreferencesLocalStorageItem } from "../constant";
import { GlobalRoutes } from "../../../GlobalRouter/Routes";
import { loginActions } from "../../../Services/Redux/actionCreators/userActions";
import classes from "./SingularityAccount.module.css";
import FormContentCard from "../../../Components/PageFormComponents/FormContentCard";
import useActionAfterDialogClose from "../../../Hooks/useActionAfterDialogClose";

const accountActions = {
    LOGIN: "LOGIN",
    SIGNUP: "SIGNUP",
};

const LoginBanner = ({ emailPreferences, orgImg }) => {
    const { isLoggedIn, nickname, email, entity } = useSelector((state) => state.user);
    const [isSavePreferencesModalOpen, setIsSavePreferencesModalOpen] = useState(false);
    const [typeOfAccountAction, setTypeOfAccountAction] = useState();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const shouldWaitForDialogExit = window.screen.width > 550;
    const { closeAndRun, transitionSlotProps } = useActionAfterDialogClose({
        isOpen: isSavePreferencesModalOpen,
        onClose: () => setIsSavePreferencesModalOpen(false),
        waitForExitTransition: shouldWaitForDialogExit,
    });

    const saveChanges = () => {
        let userPreferences = {
            savedEmailChanges: emailPreferences,
            savedEntity: entity,
        };
        userPreferences = JSON.stringify(userPreferences);
        localStorage.setItem(userPreferencesLocalStorageItem, userPreferences);
    };

    const handleChangeAccount = (accountAction) => {
        setIsSavePreferencesModalOpen(true);
        setTypeOfAccountAction(accountAction);
    };

    const changeAccount = () => {
        closeAndRun(async () => {
            await dispatch(loginActions.signout);
            navigate(GlobalRoutes[typeOfAccountAction].path);
        });
    };

    const changeAccountAndSaveChanges = () => {
        saveChanges();
        changeAccount();
    };

    if (isLoggedIn) {
        return (
            <>
                <FormContentCard title="Signed in as">
                    <Box className={classes.signInMedia}>
                        <Avatar
                            alt="Singularity"
                            src={orgImg || DefaultUserIcon}
                            className={classes.avatar}
                        />
                        <div className={classes.userDetails}>
                            <Typography variant="h6">{nickname}</Typography>
                            <Typography variant="subtitle2">{email}</Typography>
                        </div>
                    </Box>
                    <Box className={classes.signInRightContent}>
                        <Typography className={classes.signInSubtitle}>
                            {loggedInDetails.subtitle}
                        </Typography>
                        <Typography className={classes.signInDescription}>
                            {loggedInDetails.description}
                        </Typography>
                    </Box>
                    <Box className={classes.signInBtns}>
                        <SNETButton
                            color="primary"
                            children="Login to Another account"
                            variant="outlined"
                            onClick={() => handleChangeAccount(accountActions.LOGIN)}
                        />
                        <SNETButton
                            color="primary"
                            children="Create new account"
                            variant="outlined"
                            onClick={() => handleChangeAccount(accountActions.SIGNUP)}
                        />
                    </Box>
                </FormContentCard>
                <UserConfirmationModal
                    isModalOpen={isSavePreferencesModalOpen}
                    title="Migrate current changes to another account"
                    handleModalClose={() => setIsSavePreferencesModalOpen(false)}
                    hadleDecline={changeAccount}
                    handleConfirm={changeAccountAndSaveChanges}
                    dialogSlotProps={{ transition: transitionSlotProps }}
                />
            </>
        );
    }

    return (
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.box}>
            <Typography variant="h6">Sign in</Typography>
            <Grid item xs={12} sm={12} md={12} lg={12} className={classes.signInContent}>
                <Grid item xs={12} sm={4} md={4} lg={4} className={classes.signInMedia}>
                    <img src={signInImage} alt="Login In" />
                </Grid>
                <Grid item xs={12} sm={8} md={8} lg={8} className={classes.signInRightContent}>
                    <Typography className={classes.signInSubtitle}>
                        {loggedOutDetails.subtitle}
                    </Typography>
                    <Typography className={classes.signInDescription}>
                        {loggedOutDetails.description}
                    </Typography>
                    <div className={classes.signInBtns}>
                        <Link to={GlobalRoutes.LOGIN.path}>
                            <SNETButton
                                color="primary"
                                children="Login to singularitynet"
                                variant="outlined"
                            />
                        </Link>
                        <Link to={GlobalRoutes.SIGNUP.path}>
                            <SNETButton
                                color="primary"
                                children="Create new account"
                                variant="outlined"
                            />
                        </Link>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default LoginBanner;
